import type { ReactNode } from "react";
import { Info } from "lucide-react";

import { TipChip } from "@/components/ui/HoverTip";

/**
 * A small prompt that explains something beside a heading. It shows while the
 * pointer or focus rests on the prompt, and a click pins it for a reader on a
 * touch screen or one who wants it to stay.
 */
export function Explainer({
  label,
  testId,
  chip,
  children,
}: {
  label: string;
  testId: string;
  /** The chip's look: `key` for a Thesis list's Key. */
  chip?: "brand" | "key";
  children: ReactNode;
}) {
  return (
    <TipChip
      label={label}
      chip={chip}
      icon={<Info aria-hidden />}
      tip={children}
      testId={testId}
    />
  );
}
